/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { blockedTeamPatchSchema } from './blockedTeamPatchSchema';
import { teamSchema } from './teamSchema';

export const teamBulkPatchResponseSchema = z.object({
  get blocked() {
    return z.array(blockedTeamPatchSchema);
  },
  get updated() {
    return z.array(teamSchema);
  },
});
